<mat-card class="content-container">
  <div fxLayout="row" fxLayoutAlign="start stretch" fxFill>
    <portal-content-directory
      [text]="directoryText$ | async"
      [categories]="categories$ | async"
      [templates]="templates$ | async"
      [activeSection]="routeType$ | async"
      [packs]="packs$ | async"
      [selectedId]="categoryId$ | async"
      [activeDirectory]="openDirectory$ | async"
      [contentEditorEnabled]="contentEditorEnabled"
      (goToPage)="navigateTo($event)"
      (createFolder)="createNewFolder()"
      (editFolderName)="changeFolderName($event)"
      (openSection)="openDirectorySection($event)"
      (createPack)="createNewPack()"
      (editPackName)="editPackName($event)"
      [isGlobalPortal]="isGlobalPortal$ | async"
    >
    </portal-content-directory>
    <div fxFlex="grow">
      <portal-template-edit-form
        [text]="templateEditText$ | async"
        [template]="selectedTemplate$ | async"
        [isNew]="true"
        [creating]="creatingTemplate$ | async"
        [creatingSuccess]="false"
        [creatingError]="creatingTemplateError$ | async"
        [contentEditorEnabled]="contentEditorEnabled"
        (saveTemplate)="createTemplate($event)"
      >
      </portal-template-edit-form>
    </div>
  </div>
</mat-card>
